import { profile } from "@shared/api/services"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import { toast } from "react-toastify"

export const useUpdateInstruments = (options) => {
	const queryClient = useQueryClient()

	const mutation = useMutation({
		...options,
		mutationFn: (data) => profile.updateInstruments(data),
		onSuccess: (data, variables, context) => {
			queryClient.invalidateQueries(['profile'])
			toast.success('Данные обновлены')
			options?.onSuccess?.(data, variables, context)
		},
	})

	return mutation
}